import styled from 'styled-components';
import { IconButton } from '../../input/IconButton';
import { Typography } from '../../typography/Typography';

export const Title = styled(Typography)
    .withConfig({ displayName: 'Title' })
    .attrs((props) => ({
        ...props,
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }))`
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

export const RemoveButton = styled(IconButton)
    .withConfig({
        displayName: 'RemoveButton',
    })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        top: 1.5,
        right: 1.5,
        width: 24,
        height: 24,
        borderRadius: 1,
    }))``;
